var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content)?_c('content-string-edit',{attrs:{"content":_vm.content,"back-route":{ name: 'system-content-strings' }}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/content/strings/edit.vue?vue&type=template&id=3e04d0c1
// module id = lDCE
// module chunks = 0